import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_DEV,
});

export const createRetreatType = (data) =>
  API.post("/app/retreat-types", data);

export const getRetreatTypes = () =>
  API.get("/app/retreat-types");

export const deleteRetreatType = (id) =>
  API.delete(`/app/retreat-types/${id}`);

export const updateRetreatType = (id, data) =>
  API.put(`/app/retreat-types/${id}`, data);
export const getRetreatTypeById = (id) =>
  API.get(`/app/retreat-types/${id}`);

